<template>
  <div
    @contextmenu.prevent="null"
    class="mainContainer"
    style="user-select: none; cursor: default;"
  >
    <template v-if="navigation.searchVisible">
      <v-card
        :border="$vuetify.display.width > 1200 ? 'e' : null"
        elevation="0"
        rounded="0"
        color="border"
        class="navigationContainer"
      > 
        <v-card elevation="0" rounded="0" color="primary" style="width: 100%; padding: 15px; display: flex; align-items: center;">
          <v-icon size="large" color="indigo">mdi-source-branch</v-icon>
          <v-icon color="indigo">mdi-package</v-icon>
          <v-icon size="small" color="indigo" style="margin-right: 10px;">mdi-chart-bar</v-icon>
          <h4>REPORTE DE SEGUIMIENTOS DE PRODUCTO</h4>
          <div style="margin-left: auto; display: flex; align-items: center; gap: 5px;">
            <v-icon
              @click="selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView()"
              :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
              size="x-small"
              class="hoverableElement"
            >
              mdi-magnify
            </v-icon>
            <v-icon
              @click="setDefaultValues()"
              :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
              size="x-small"
              class="hoverableElement"
            >
              mdi-backspace
            </v-icon>
            <v-icon
              @click="$generalFunctions.default.copyToClipboard(this, 'Búsqueda de reporte de seguimientos de producto', 'a', null)"
              :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
              size="x-small"
              class="hoverableElement"
            >
              mdi-share-variant
            </v-icon>
            <template v-if="display.CRMWhatsappProductFollowupSummary != null && navigation.noData == false && $vuetify.display.width > 1200">
              <v-icon
                @click="navigation.searchVisible = false"
                :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
                class="hoverableElement"
              >
                mdi-arrow-left-bottom-bold
              </v-icon>
            </template>
          </div>
        </v-card> 
        <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px;"></v-card>
        <div style="flex: 1; width: 100%; padding: 15px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none; scrollbar-color: #3F51B5 transparent;">
          <div style="display: flex; align-items: center;">
            <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros del seguimiento de producto:</strong></span>
            <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
          </div>
          <v-menu
            @contextmenu.prevent="null"
            :close-on-content-click="false"
            transition="scroll-y-transition"
            scrim="black"
            opacity="0.8"
            style="user-select: none; cursor: default;"
          >
            <template v-slot:activator="{ props }">
              <v-text-field
                v-bind="props"
                v-model="computed_formattedDate"
                @click:clear="input.date = Array.from({length: new Date().getDate()}, (_, i) => new Date(new Date().getFullYear(), new Date().getMonth(), i + 1)); updateURLSearchQuery(); updateURLSearchQuery();"
                :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
                :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
                :label="input.date.length > 1 ? 'Filtrar por rango de fechas de generación' : 'Filtrar por fecha de generación'"
                prepend-inner-icon="mdi-calendar"
                variant="outlined"
                density="compact"
                autocomplete="off"
                clear-icon="mdi-backspace"
                hide-details
                readonly
                clearable
                style="margin-top: 15px;"
              >
              </v-text-field>
            </template>
            <v-card style="display: flex; flex-direction: column; align-items: center; justify-content: center; overflow-x: hidden;">
              <v-locale-provider locale="es">
                <v-date-picker
                  v-model="input.date"
                  @update:model-value="input.date = input.date.length == 0 ? [new Date()] : input.date; updateURLSearchQuery();"
                  :max="new Date()"
                  multiple="range"
                  color="indigo"
                  hide-header
                ></v-date-picker>
              </v-locale-provider>
              <div style="width: 100%; display: flex; justify-content: center; align-items: center; flex-wrap: wrap; gap: 5px; margin-bottom: 5px;">
                <template 
                  v-for="day in display.days"
                  v-bind:key="day"
                >
                  <v-chip 
                    @click="input.date = Array.from({length: day}, (_, i) => new Date(new Date().setDate(new Date().getDate() - (day - 1 - i)))); updateURLSearchQuery();"
                    color="indigo"
                    variant="flat"
                    elevation="2"
                    density="compact"
                    label
                    class="hoverableVChip"
                    style="border: 2px solid #343a40;"
                  >
                    <p><strong>{{ day }} D</strong></p>
                  </v-chip>
                </template>
              </div>
              <div style="width: 100%; display: flex; justify-content: center; align-items: center; flex-wrap: wrap; gap: 5px; margin-bottom: 10px;">
                <v-chip 
                  @click="input.date = [new Date()]; updateURLSearchQuery();"
                  color="indigo"
                  variant="flat"
                  elevation="2"
                  density="compact"
                  label
                  class="hoverableVChip"
                  style="border: 2px solid #343a40;"
                >
                  <p><strong>Hoy</strong></p>
                </v-chip>
                <v-chip 
                  @click="input.date = Array.from({length: (new Date().getDay() || 7) - 1 + 1}, (_, i) => { const d = new Date(); d.setDate(d.getDate() - ((new Date().getDay() + 6) % 7) + i); return d; }); updateURLSearchQuery();"
                  color="indigo"
                  variant="flat"
                  elevation="2"
                  density="compact"
                  label
                  class="hoverableVChip"
                  style="border: 2px solid #343a40;"
                >
                  <p><strong>Esta semana</strong></p>
                </v-chip>  
                <v-chip 
                  @click="input.date = Array.from({length: new Date().getDate()}, (_, i) => { const d = new Date(); d.setDate(i + 1); return d; }); updateURLSearchQuery();"
                  color="indigo"
                  variant="flat"
                  elevation="2"
                  density="compact"
                  label
                  class="hoverableVChip"
                  style="border: 2px solid #343a40;"
                >
                  <p><strong>Este mes</strong></p>
                </v-chip>
                <v-chip 
                  @click="input.date = Array.from({length: Math.floor((new Date() - new Date(new Date().getFullYear(), 0, 1)) / 86400000) + 1}, (_, i) => new Date(new Date(new Date().getFullYear(), 0, 1).setDate(i + 1))); updateURLSearchQuery();"
                  color="indigo"
                  variant="flat"
                  elevation="2"
                  density="compact"
                  label
                  class="hoverableVChip"
                  style="border: 2px solid #343a40;"
                >
                  <p><strong>Este año</strong></p>
                </v-chip>
              </div>
              <p style="font-size: x-small; color: #9e9e9e; text-align: center; margin-top: 5px; margin-bottom: 5px;">Presiona estos atajos para seleccionar un rango de fechas</p>
            </v-card>
          </v-menu>
          <v-autocomplete
            ref="CRMWhatsappContactID"
            v-model="input.CRMWhatsappContactID"
            v-model:search="input.searchedCRMWhatsappContactID"
            @update:model-value="input.allCRMWhatsappContactIDSelected = input.CRMWhatsappContactID.length == display.CRMWhatsappContact.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="computed_CRMWhatsappContact"
            item-value="CRMWhatsappContactID"
            item-title="CRMWhatsappContactName"
            label="Filtrar por contacto"
            prepend-inner-icon="mdi-account"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip color="secondary" variant="flat" elevation="2" label>
                  <p>{{ display.CRMWhatsappContact.find(currentCRMWhatsappContact => currentCRMWhatsappContact.CRMWhatsappContactID == item.value) ? display.CRMWhatsappContact.find(currentCRMWhatsappContact => currentCRMWhatsappContact.CRMWhatsappContactID == item.value).CRMWhatsappContactName || 'No registrado' : item.raw.CRMWhatsappContactName }}</p>
                  <template v-slot:close>
                    <v-icon 
                      @click="input.CRMWhatsappContactID = input.CRMWhatsappContactID.filter(currentCRMWhatsappContactID => currentCRMWhatsappContactID != item.value); updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappContactID')"
                      class="hoverableVIcon"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappContactID.length - 3 }} {{ input.CRMWhatsappContactID.length - 3 == 1 ? 'contacto' : 'contactos' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.CRMWhatsappContact.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allCRMWhatsappContactIDSelected = !input.allCRMWhatsappContactIDSelected; input.allCRMWhatsappContactIDSelected ? input.CRMWhatsappContactID = display.CRMWhatsappContact.map(currentCRMWhatsappContact => currentCRMWhatsappContact.CRMWhatsappContactID) : input.CRMWhatsappContactID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allCRMWhatsappContactIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allCRMWhatsappContactIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allCRMWhatsappContactIDSelected">
                        <p>Deseleccionar todos los contactos</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.CRMWhatsappContact.length - input.CRMWhatsappContactID.length) == 1 ? 'el' : 'los' }}{{ (display.CRMWhatsappContact.length - input.CRMWhatsappContactID.length) > 1 ? ` ${(display.CRMWhatsappContact.length - input.CRMWhatsappContactID.length)}` : '' }} contacto{{ (display.CRMWhatsappContact.length - input.CRMWhatsappContactID.length) == 1 ? '' : 's' }} restante{{ (display.CRMWhatsappContact.length - input.CRMWhatsappContactID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.CRMWhatsappContactID.includes(item.raw.CRMWhatsappContactID) ? input.CRMWhatsappContactID = input.CRMWhatsappContactID.filter(CRMWhatsappContactID => CRMWhatsappContactID != item.raw.CRMWhatsappContactID) : input.CRMWhatsappContactID.push(item.raw.CRMWhatsappContactID); input.allCRMWhatsappContactIDSelected = input.CRMWhatsappContactID.length == display.CRMWhatsappContact.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.CRMWhatsappContactID.includes(item.raw.CRMWhatsappContactID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.CRMWhatsappContactID.includes(item.raw.CRMWhatsappContactID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <p>{{ item.raw.CRMWhatsappContactName }}</p>
                  <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(item.raw.CRMWhatsappContactPhoneNumber, false) }}</p>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="CRMLocalityID"
            v-model="input.CRMLocalityID"
            @update:model-value="input.allCRMLocalityIDSelected = input.CRMLocalityID.length == systemInformationData.CRMLocalities.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="systemInformationData.CRMLocalities"
            item-value="CRMLocalityID"
            item-title="CRMLocalityName"
            label="Filtrar por localidad"
            prepend-inner-icon="mdi-store"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip
                  :color="item.raw.CRMLocalityColor || 'primary'"
                  variant="flat"
                  elevation="2"
                  label
                >
                  <p>{{ item.raw.CRMLocalityName }}</p>
                  <template v-slot:close>
                    <v-icon
                      @click.stop="input.CRMLocalityID = input.CRMLocalityID.filter(CRMLocalityID => CRMLocalityID != item.value); input.allCRMLocalityIDSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMLocalityID');"
                      size="smaller"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMLocalityID.length - 3 }} {{ input.CRMLocalityID.length - 3 == 1 ? 'localidad' : 'localidades' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && systemInformationData.CRMLocalities.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allCRMLocalityIDSelected = !input.allCRMLocalityIDSelected; input.allCRMLocalityIDSelected ? input.CRMLocalityID = systemInformationData.CRMLocalities.map(currentCRMLocality => currentCRMLocality.CRMLocalityID) : input.CRMLocalityID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allCRMLocalityIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allCRMLocalityIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allCRMLocalityIDSelected">
                        <p>Deseleccionar todos las localidades</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (systemInformationData.CRMLocalities.length - input.CRMLocalityID.length) == 1 ? 'la' : 'las' }}{{ (systemInformationData.CRMLocalities.length - input.CRMLocalityID.length) > 1 ? ` ${(systemInformationData.CRMLocalities.length - input.CRMLocalityID.length)}` : '' }} localidad{{ (systemInformationData.CRMLocalities.length - input.CRMLocalityID.length) == 1 ? '' : 'es' }} restante{{ (systemInformationData.CRMLocalities.length - input.CRMLocalityID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.CRMLocalityID.includes(item.raw.CRMLocalityID) ? input.CRMLocalityID = input.CRMLocalityID.filter(CRMLocalityID => CRMLocalityID != item.raw.CRMLocalityID) : input.CRMLocalityID.push(item.raw.CRMLocalityID); input.allCRMLocalityIDSelected = input.CRMLocalityID.length == systemInformationData.CRMLocalities.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.CRMLocalityID.includes(item.raw.CRMLocalityID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.CRMLocalityID.includes(item.raw.CRMLocalityID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <v-chip
                    :color="item.raw.CRMLocalityColor || 'primary'"
                    variant="flat"
                    density="compact"
                    elevation="2"
                    label
                    style="margin-top: 5px; margin-bottom: 5px; padding-left: 10px;"
                  >
                    <p>{{ item.raw.CRMLocalityName }}</p>
                  </v-chip>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="CRMAgentID"
            v-model="input.CRMAgentID"
            @update:model-value="input.allCRMAgentIDSelected = input.CRMAgentID.length == systemInformationData.CRMAgents.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="systemInformationData.CRMAgents"
            item-value="CRMAgentID"
            item-title="CRMAgentName"
            label="Filtrar por agente generador"
            prepend-inner-icon="mdi-briefcase-account"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip
                  :color="item.raw.CRMAgentColor || 'primary'"
                  variant="flat"
                  elevation="2"
                  label
                >
                  <img
                    :src="item.raw.CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')"
                    draggable="false"
                    class="hoverableImage"
                    style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                  >
                  <p>{{ item.raw.CRMAgentName }}</p>
                  <template v-slot:close>
                    <v-icon
                      @click.stop="input.CRMAgentID = input.CRMAgentID.filter(CRMAgentID => CRMAgentID != item.value); input.allCRMAgentIDSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMAgentID');"
                      size="smaller"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMAgentID.length - 3 }} {{ input.CRMAgentID.length - 3 == 1 ? 'agente' : 'agentes' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && systemInformationData.CRMAgents.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allCRMAgentIDSelected = !input.allCRMAgentIDSelected; input.allCRMAgentIDSelected ? input.CRMAgentID = systemInformationData.CRMAgents.map(currentCRMAgent => currentCRMAgent.CRMAgentID) : input.CRMAgentID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allCRMAgentIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allCRMAgentIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allCRMAgentIDSelected">
                        <p>Deseleccionar todos los agentes generadores</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (systemInformationData.CRMAgents.length - input.CRMAgentID.length) == 1 ? 'el' : 'los' }}{{ (systemInformationData.CRMAgents.length - input.CRMAgentID.length) > 1 ? ` ${(systemInformationData.CRMAgents.length - input.CRMAgentID.length)}` : '' }} agente generador{{ (systemInformationData.CRMAgents.length - input.CRMAgentID.length) == 1 ? '' : 's' }} restante{{ (systemInformationData.CRMAgents.length - input.CRMAgentID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.CRMAgentID.includes(item.raw.CRMAgentID) ? input.CRMAgentID = input.CRMAgentID.filter(CRMAgentID => CRMAgentID != item.raw.CRMAgentID) : input.CRMAgentID.push(item.raw.CRMAgentID); input.allCRMAgentIDSelected = input.CRMAgentID.length == systemInformationData.CRMAgents.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.CRMAgentID.includes(item.raw.CRMAgentID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.CRMAgentID.includes(item.raw.CRMAgentID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <v-chip
                    :color="item.raw.CRMAgentColor || 'primary'"
                    variant="flat"
                    density="compact"
                    elevation="2"
                    label
                    style="margin-top: 5px; margin-bottom: 5px; padding-left: 10px;"
                  >
                    <div style="display: flex; align-items: center;">
                      <img
                        @click.stop="$root.dialogControllerComponent.openDialog('imageDialog', {'imageURL': item.raw.CRMAgentProfilePictureURL})"
                        :src="item.raw.CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')"
                        draggable="false"
                        class="hoverableImage"
                        style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                      >
                      <p>{{ item.raw.CRMAgentName }}</p>
                    </div>
                  </v-chip>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="CRMWhatsappProductFollowupStatus"
            v-model="input.CRMWhatsappProductFollowupStatus"
            @update:model-value="input.allCRMWhatsappProductFollowupStatusSelected = input.CRMWhatsappProductFollowupStatus.length == display.CRMWhatsappProductFollowupStatus.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="display.CRMWhatsappProductFollowupStatus"
            label="Filtrar por estado"
            prepend-inner-icon="mdi-source-branch"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip
                  :color="item.raw.color || 'primary'"
                  variant="flat"
                  elevation="2"
                  label
                >
                  <p>{{ item.raw.title }}</p>
                  <template v-slot:close>
                    <v-icon
                      @click.stop="input.CRMWhatsappProductFollowupStatus = input.CRMWhatsappProductFollowupStatus.filter(CRMWhatsappProductFollowupStatus => CRMWhatsappProductFollowupStatus != item.raw.value); input.allCRMWhatsappProductFollowupStatusSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappProductFollowupStatus');"
                      size="smaller"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappProductFollowupStatus.length - 3 }} {{ input.CRMWhatsappProductFollowupStatus.length - 3 == 1 ? 'estado' : 'estados' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.CRMWhatsappProductFollowupStatus.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allCRMWhatsappProductFollowupStatusSelected = !input.allCRMWhatsappProductFollowupStatusSelected; input.allCRMWhatsappProductFollowupStatusSelected ? input.CRMWhatsappProductFollowupStatus = display.CRMWhatsappProductFollowupStatus.map(currentCRMWhatsappProductFollowupStatus => currentCRMWhatsappProductFollowupStatus.value) : input.CRMWhatsappProductFollowupStatus.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allCRMWhatsappProductFollowupStatusSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allCRMWhatsappProductFollowupStatusSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allCRMWhatsappProductFollowupStatusSelected">
                        <p>Deseleccionar todos los estados</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.CRMWhatsappProductFollowupStatus.length - input.CRMWhatsappProductFollowupStatus.length) == 1 ? 'el' : 'los' }}{{ (display.CRMWhatsappProductFollowupStatus.length - input.CRMWhatsappProductFollowupStatus.length) > 1 ? ` ${(display.CRMWhatsappProductFollowupStatus.length - input.CRMWhatsappProductFollowupStatus.length)}` : '' }} estado{{ (display.CRMWhatsappProductFollowupStatus.length - input.CRMWhatsappProductFollowupStatus.length) == 1 ? '' : 's' }} restante{{ (display.CRMWhatsappProductFollowupStatus.length - input.CRMWhatsappProductFollowupStatus.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.CRMWhatsappProductFollowupStatus.includes(item.raw.value) ? input.CRMWhatsappProductFollowupStatus = input.CRMWhatsappProductFollowupStatus.filter(CRMWhatsappProductFollowupStatus => CRMWhatsappProductFollowupStatus != item.raw.value) : input.CRMWhatsappProductFollowupStatus.push(item.raw.value); input.allCRMWhatsappProductFollowupStatusSelected = input.CRMWhatsappProductFollowupStatus.length == display.CRMWhatsappProductFollowupStatus.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.CRMWhatsappProductFollowupStatus.includes(item.raw.value)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.CRMWhatsappProductFollowupStatus.includes(item.raw.value)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <v-chip
                    :color="item.raw.color || 'primary'"
                    variant="flat"
                    density="compact"
                    elevation="2"
                    label
                    style="margin-top: 5px; margin-bottom: 5px; padding-left: 10px;"
                  >
                    <p>{{ item.raw.title }}</p>
                  </v-chip>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-textarea
            v-model="input.CRMWhatsappProductFollowupNote"
            @update:model-value="updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            label="Filtrar por nota"
            prepend-inner-icon="mdi-note"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            rows="3"
            max-rows="3"
            no-resize
            clearable
            hide-details
            style="margin-top: 15px;"
          ></v-textarea>
          <div style="display: flex; align-items: center; margin-top: 30px;">
            <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros del producto:</strong></span>
            <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
          </div>
          <v-autocomplete
            ref="productID"
            v-model="input.productID"
            v-model:search="input.searchedProductID"
            @keydown.enter.prevent="appendProductIntoProductID()"
            @update:model-value="input.allProductIDSelected = input.productID.length == display.product.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="display.product"
            item-value="productID"
            item-title="productAutocomplete"
            label="Filtrar por producto"
            prepend-inner-icon="mdi-package"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip color="secondary" variant="flat" elevation="2" label>
                  <img
                    :src="item.raw.productImageURL || require('@/assets/images/placeholderImage.png')"
                    draggable="false"
                    class="hoverableImage"
                    style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover; margin-right: 10px; border: 2px solid #3F51B5; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);"
                  >
                  <p>{{ item.raw.productName }}</p>
                  <template v-slot:close>
                    <v-icon
                      @click.stop="input.productID = input.productID.filter(productID => productID != item.value); input.searchedProductID = null; input.allProductIDSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'productID');"
                      size="smaller"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.productID.length - 3 }} {{ input.productID.length - 3 == 1 ? 'producto' : 'productos' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.product.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allProductIDSelected = !input.allProductIDSelected; input.allProductIDSelected ? input.productID = display.product.map(currentProduct => currentProduct.productID) : input.productID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allProductIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allProductIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allProductIDSelected">
                        <p>Deseleccionar todos los productos</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.product.length - input.productID.length) == 1 ? 'el' : 'los' }}{{ (display.product.length - input.productID.length) > 1 ? ` ${(display.product.length - input.productID.length)}` : '' }} producto{{ (display.product.length - input.productID.length) == 1 ? '' : 's' }} restante{{ (display.product.length - input.productID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.productID.includes(item.raw.productID) ? input.productID = input.productID.filter(productID => productID != item.raw.productID) : input.productID.push(item.raw.productID); input.allProductIDSelected = input.productID.length == display.product.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.productID.includes(item.raw.productID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.productID.includes(item.raw.productID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <div style="display: flex; align-items: center; padding-left: 10px;">
                    <img
                      @click.stop="$root.dialogControllerComponent.openDialog('imageDialog', {'imageURL': item.raw.productImageURL})"
                      :src="item.raw.productImageURL || require('@/assets/images/placeholderImage.png')"
                      draggable="false"
                      class="hoverableImage"
                      style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px; border: 2px solid #3F51B5; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);"
                    >
                    <div>
                      <p>{{ item.raw.productName }}</p>
                      <p style="font-size: smaller; color: #3F51B5;"><strong>{{ item.raw.productSKU }}</strong></p>
                    </div>
                  </div>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="productCategoryID"
            v-model="input.productCategoryID"
            @update:model-value="input.allProductCategoryIDSelected = input.productCategoryID.length == display.productCategory.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="display.productCategory"
            item-value="productCategoryID"
            item-title="productCategoryName"
            label="Filtrar por categoría de producto"
            prepend-inner-icon="mdi-cog"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip color="secondary" variant="flat" elevation="2" label>
                  <p>{{ item.raw.productCategoryName }}</p>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.productCategoryID.length - 3 }} {{ input.productCategoryID.length - 3 == 1 ? 'categoría de producto' : 'categorías de producto' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.productCategory.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allProductCategoryIDSelected = !input.allProductCategoryIDSelected; input.allProductCategoryIDSelected ? input.productCategoryID = display.productCategory.map(currentProductCategory => currentProductCategory.productCategoryID) : input.productCategoryID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allProductCategoryIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allProductCategoryIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allProductCategoryIDSelected">
                        <p>Deseleccionar todas las categorías de producto</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.productCategory.length - input.productCategoryID.length) == 1 ? 'la' : 'las' }}{{ (display.productCategory.length - input.productCategoryID.length) > 1 ? ` ${(display.productCategory.length - input.productCategoryID.length)}` : '' }} categoría{{ (display.productCategory.length - input.productCategoryID.length) == 1 ? '' : 's' }} de producto restante{{ (display.productCategory.length - input.productCategoryID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.productCategoryID.includes(item.raw.productCategoryID) ? input.productCategoryID = input.productCategoryID.filter(productCategoryID => productCategoryID != item.raw.productCategoryID) : input.productCategoryID.push(item.raw.productCategoryID); input.allProductCategoryIDSelected = input.productCategoryID.length == display.productCategory.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.productCategoryID.includes(item.raw.productCategoryID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.productCategoryID.includes(item.raw.productCategoryID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <p>{{ item.raw.productCategoryName }}</p>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="productBrandID"
            v-model="input.productBrandID"
            @update:model-value="input.allProductBrandIDSelected = input.productBrandID.length == display.productBrand.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="display.productBrand"
            item-value="productBrandID"
            item-title="productBrandName"
            label="Filtrar por marca de producto"
            prepend-inner-icon="mdi-archive"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip color="secondary" variant="flat" elevation="2" label>
                  <p>{{ item.raw.productBrandName }}</p>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.productBrandID.length - 3 }} {{ input.productBrandID.length - 3 == 1 ? 'marca de producto' : 'marcas de producto' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.productBrand.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allProductBrandIDSelected = !input.allProductBrandIDSelected; input.allProductBrandIDSelected ? input.productBrandID = display.productBrand.map(currentProductBrand => currentProductBrand.productBrandID) : input.productBrandID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allProductBrandIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allProductBrandIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allProductBrandIDSelected">
                        <p>Deseleccionar todas las marcas de producto</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.productBrand.length - input.productBrandID.length) == 1 ? 'la' : 'las' }}{{ (display.productBrand.length - input.productBrandID.length) > 1 ? ` ${(display.productBrand.length - input.productBrandID.length)}` : '' }} marca{{ (display.productBrand.length - input.productBrandID.length) == 1 ? '' : 's' }} de producto restante{{ (display.productBrand.length - input.productBrandID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.productBrandID.includes(item.raw.productBrandID) ? input.productBrandID = input.productBrandID.filter(productBrandID => productBrandID != item.raw.productBrandID) : input.productBrandID.push(item.raw.productBrandID); input.allProductBrandIDSelected = input.productBrandID.length == display.productBrand.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.productBrandID.includes(item.raw.productBrandID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.productBrandID.includes(item.raw.productBrandID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <p>{{ item.raw.productBrandName }}</p>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="productModelID"
            v-model="input.productModelID"
            @update:model-value="input.allProductModelIDSelected = input.productModelID.length == display.productModel.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="display.productModel"
            item-value="productModelID"
            item-title="productModelName"
            label="Filtrar por modelo de producto"
            prepend-inner-icon="mdi-source-branch"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip color="secondary" variant="flat" elevation="2" label>
                  <p>{{ item.raw.productModelName }}</p>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.productModelID.length - 3 }} {{ input.productModelID.length - 3 == 1 ? 'modelo de producto' : 'modelos de producto' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.productModel.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allProductModelIDSelected = !input.allProductModelIDSelected; input.allProductModelIDSelected ? input.productModelID = display.productModel.map(currentProductModel => currentProductModel.productModelID) : input.productModelID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allProductModelIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allProductModelIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allProductModelIDSelected">
                        <p>Deseleccionar todos los modelos de producto</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.productModel.length - input.productModelID.length) == 1 ? 'el' : 'los' }}{{ (display.productModel.length - input.productModelID.length) > 1 ? ` ${(display.productModel.length - input.productModelID.length)}` : '' }} modelo{{ (display.productModel.length - input.productModelID.length) == 1 ? '' : 's' }} de producto restante{{ (display.productModel.length - input.productModelID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.productModelID.includes(item.raw.productModelID) ? input.productModelID = input.productModelID.filter(productModelID => productModelID != item.raw.productModelID) : input.productModelID.push(item.raw.productModelID); input.allProductModelIDSelected = input.productModelID.length == display.productModel.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.productModelID.includes(item.raw.productModelID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.productModelID.includes(item.raw.productModelID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <p>{{ item.raw.productModelName }}</p>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="productFlavorID"
            v-model="input.productFlavorID"
            @update:model-value="input.allProductFlavorIDSelected = input.productFlavorID.length == display.productFlavor.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="display.productFlavor"
            item-value="productFlavorID"
            item-title="productFlavorName"
            label="Filtrar por sabor de producto"
            prepend-inner-icon="mdi-water"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip color="secondary" variant="flat" elevation="2" label>
                  <p>{{ item.raw.productFlavorName }}</p>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.productFlavorID.length - 3 }} {{ input.productFlavorID.length - 3 == 1 ? 'sabor de producto' : 'sabores de producto' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.productFlavor.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allProductFlavorIDSelected = !input.allProductFlavorIDSelected; input.allProductFlavorIDSelected ? input.productFlavorID = display.productFlavor.map(currentProductFlavor => currentProductFlavor.productFlavorID) : input.productFlavorID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allProductFlavorIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allProductFlavorIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allProductFlavorIDSelected">
                        <p>Deseleccionar todos los sabores de producto</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.productFlavor.length - input.productFlavorID.length) == 1 ? 'el' : 'los' }}{{ (display.productFlavor.length - input.productFlavorID.length) > 1 ? ` ${(display.productFlavor.length - input.productFlavorID.length)}` : '' }} sabor{{ (display.productFlavor.length - input.productFlavorID.length) == 1 ? '' : 'es' }} de producto restante{{ (display.productFlavor.length - input.productFlavorID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.productFlavorID.includes(item.raw.productFlavorID) ? input.productFlavorID = input.productFlavorID.filter(productFlavorID => productFlavorID != item.raw.productFlavorID) : input.productFlavorID.push(item.raw.productFlavorID); input.allProductFlavorIDSelected = input.productFlavorID.length == display.productFlavor.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.productFlavorID.includes(item.raw.productFlavorID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.productFlavorID.includes(item.raw.productFlavorID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <p>{{ item.raw.productFlavorName }}</p>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="productNicotineLevelID"
            v-model="input.productNicotineLevelID"
            @update:model-value="input.allProductNicotineLevelIDSelected = input.productNicotineLevelID.length == display.productNicotineLevel.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="display.productNicotineLevel"
            item-value="productNicotineLevelID"
            item-title="productNicotineLevelName"
            label="Filtrar por nivel de nicotina"
            prepend-inner-icon="mdi-cloud"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip color="secondary" variant="flat" elevation="2" label>
                  <p>{{ item.raw.productNicotineLevelName }}</p>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.productNicotineLevelID.length - 3 }} {{ input.productNicotineLevelID.length - 3 == 1 ? 'nivel de nicotina de producto' : 'niveles de nicotina de producto' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.productNicotineLevel.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allProductNicotineLevelIDSelected = !input.allProductNicotineLevelIDSelected; input.allProductNicotineLevelIDSelected ? input.productNicotineLevelID = display.productNicotineLevel.map(currentProductNicotineLevel => currentProductNicotineLevel.productNicotineLevelID) : input.productNicotineLevelID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allProductNicotineLevelIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allProductNicotineLevelIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allProductNicotineLevelIDSelected">
                        <p>Deseleccionar todos los niveles de nicotina de producto</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.productNicotineLevel.length - input.productNicotineLevelID.length) == 1 ? 'el' : 'los' }}{{ (display.productNicotineLevel.length - input.productNicotineLevelID.length) > 1 ? ` ${(display.productNicotineLevel.length - input.productNicotineLevelID.length)}` : '' }} nivel{{ (display.productNicotineLevel.length - input.productNicotineLevelID.length) == 1 ? '' : 'es' }} de nicotina de producto restante{{ (display.productNicotineLevel.length - input.productNicotineLevelID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.productNicotineLevelID.includes(item.raw.productNicotineLevelID) ? input.productNicotineLevelID = input.productNicotineLevelID.filter(productNicotineLevelID => productNicotineLevelID != item.raw.productNicotineLevelID) : input.productNicotineLevelID.push(item.raw.productNicotineLevelID); input.allProductNicotineLevelIDSelected = input.productNicotineLevelID.length == display.productNicotineLevel.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.productNicotineLevelID.includes(item.raw.productNicotineLevelID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.productNicotineLevelID.includes(item.raw.productNicotineLevelID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <p>{{ item.raw.productNicotineLevelName }}</p>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="productSizeID"
            v-model="input.productSizeID"
            @update:model-value="input.allProductSizeIDSelected = input.productSizeID.length == display.productSize.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="display.productSize"
            item-value="productSizeID"
            item-title="productSizeName"
            label="Filtrar por tamaño de producto"
            prepend-inner-icon="mdi-signal"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip color="secondary" variant="flat" elevation="2" label>
                  <p>{{ item.raw.productSizeName }}</p>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.productSizeID.length - 3 }} {{ input.productSizeID.length - 3 == 1 ? 'tamaño de producto' : 'tamaños de producto' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.productSize.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allProductSizeIDSelected = !input.allProductSizeIDSelected; input.allProductSizeIDSelected ? input.productSizeID = display.productSize.map(currentProductSize => currentProductSize.productSizeID) : input.productSizeID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allProductSizeIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allProductSizeIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allProductSizeIDSelected">
                        <p>Deseleccionar todos los tamaños de producto</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.productSize.length - input.productSizeID.length) == 1 ? 'el' : 'los' }}{{ (display.productSize.length - input.productSizeID.length) > 1 ? ` ${(display.productSize.length - input.productSizeID.length)}` : '' }} tamaño{{ (display.productSize.length - input.productSizeID.length) == 1 ? '' : 's' }} de producto restante{{ (display.productSize.length - input.productSizeID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.productSizeID.includes(item.raw.productSizeID) ? input.productSizeID = input.productSizeID.filter(productSizeID => productSizeID != item.raw.productSizeID) : input.productSizeID.push(item.raw.productSizeID); input.allProductSizeIDSelected = input.productSizeID.length == display.productSize.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.productSizeID.includes(item.raw.productSizeID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.productSizeID.includes(item.raw.productSizeID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <p>{{ item.raw.productSizeName }}</p>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="productProviderID"
            v-model="input.productProviderID"
            @update:model-value="input.allProductProviderIDSelected = input.productProviderID.length == display.productProvider.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="display.productProvider"
            item-value="productProviderID"
            item-title="productProviderName"
            label="Filtrar por proveedor de producto"
            prepend-inner-icon="mdi-briefcase"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip color="secondary" variant="flat" elevation="2" label>
                  <p>{{ item.raw.productProviderName }}</p>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.productProviderID.length - 3 }} {{ input.productProviderID.length - 3 == 1 ? 'proveedor de producto' : 'proveedores de producto' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.productProvider.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allProductProviderIDSelected = !input.allProductProviderIDSelected; input.allProductProviderIDSelected ? input.productProviderID = display.productProvider.map(currentProductProvider => currentProductProvider.productProviderID) : input.productProviderID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allProductProviderIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allProductProviderIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allProductProviderIDSelected">
                        <p>Deseleccionar todos los proveedores de producto</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.productProvider.length - input.productProviderID.length) == 1 ? 'el' : 'los' }}{{ (display.productProvider.length - input.productProviderID.length) > 1 ? ` ${(display.productProvider.length - input.productProviderID.length)}` : '' }} proveedor{{ (display.productProvider.length - input.productProviderID.length) == 1 ? '' : 'es' }} de producto restante{{ (display.productProvider.length - input.productProviderID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.productProviderID.includes(item.raw.productProviderID) ? input.productProviderID = input.productProviderID.filter(productProviderID => productProviderID != item.raw.productProviderID) : input.productProviderID.push(item.raw.productProviderID); input.allProductProviderIDSelected = input.productProviderID.length == display.productProvider.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.productProviderID.includes(item.raw.productProviderID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.productProviderID.includes(item.raw.productProviderID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <p>{{ item.raw.productProviderName }}</p>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
          <v-autocomplete
            ref="productTagID"
            v-model="input.productTagID"
            @update:model-value="input.allProductTagIDSelected = input.productTagID.length == display.productTag.length; updateURLSearchQuery();"
            :loading="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
            :items="display.productTag"
            item-value="productTagID"
            item-title="productTagName"
            label="Filtrar por etiqueta de producto"
            prepend-inner-icon="mdi-tag"
            clear-icon="mdi-backspace"
            variant="outlined"
            density="compact"
            autocomplete="off"
            multiple
            chips
            closable-chips
            clearable
            hide-no-data
            hide-details
            style="margin-top: 15px;"
          >
            <template v-slot:chip="{ item, index }">
              <template v-if="index < 3">
                <v-chip color="secondary" variant="flat" elevation="2" label>
                  <p>{{ item.raw.productTagName }}</p>
                </v-chip>
              </template>
              <template v-else-if="index == 3">
                <p style="color: #9e9e9e; font-size: small;">(+{{ input.productTagID.length - 3 }} {{ input.productTagID.length - 3 == 1 ? 'etiqueta de producto' : 'etiquetas de producto' }})</p>
              </template>
            </template>
            <template v-slot:item="{ item, index }">
              <template v-if="index == 0 && display.productTag.length > 1">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="input.allProductTagIDSelected = !input.allProductTagIDSelected; input.allProductTagIDSelected ? input.productTagID = display.productTag.map(currentProductTag => currentProductTag.productTagID) : input.productTagID.length = 0; updateURLSearchQuery();"
                    :title="null" 
                    :subtitle="null"
                    :active="input.allProductTagIDSelected"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-switch
                        :model-value="input.allProductTagIDSelected"
                        density="compact"
                        color="indigo"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 20px;"
                      ></v-switch>
                      <template v-if="input.allProductTagIDSelected">
                        <p>Deseleccionar todos los etiquetas de producto</p>
                      </template>
                      <template v-else>
                        <p>Seleccionar {{ (display.productTag.length - input.productTagID.length) == 1 ? 'la' : 'las' }}{{ (display.productTag.length - input.productTagID.length) > 1 ? ` ${(display.productTag.length - input.productTagID.length)}` : '' }} etiqueta{{ (display.productTag.length - input.productTagID.length) == 1 ? '' : 's' }} de producto restante{{ (display.productTag.length - input.productTagID.length) == 1 ? '' : 's' }}</p>
                      </template>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                <v-list-item
                  @click="input.productTagID.includes(item.raw.productTagID) ? input.productTagID = input.productTagID.filter(productTagID => productTagID != item.raw.productTagID) : input.productTagID.push(item.raw.productTagID); input.allProductTagIDSelected = input.productTagID.length == display.productTag.length; updateURLSearchQuery();"
                  :title="null" 
                  :subtitle="null"
                  :active="input.productTagID.includes(item.raw.productTagID)"
                  class="hoverableVListItem"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn 
                      :model-value="input.productTagID.includes(item.raw.productTagID)"
                      density="compact"
                      readonly
                      hide-details
                      class="hoverableVIcon"
                      style="margin-right: 10px;"
                    ></v-checkbox-btn>
                  </template>
                  <p>{{ item.raw.productTagName }}</p>
                </v-list-item>
              </v-list>
            </template>
          </v-autocomplete>
        </div>
        <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px;"></v-card>
        <v-card color="primary" elevation="0" rounded="0" style="width: 100%; height: 120px; padding: 15px; overflow: hidden; align-items: center; justify-content: center;">
          <v-btn 
            @click="selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView()"
            :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView" 
            block
            color="indigo"
            class="hoverableVButton"
          >
            <v-icon size="large" start>mdi-magnify</v-icon>
            <h3>BUSCAR</h3>
          </v-btn>
          <v-tooltip
            :disabled="systemInformationData.tooltipDisabled"
            open-delay="1000"
            location="top"
          >
            <template v-slot:activator="{ props }">
              <v-btn 
                v-bind="props" 
                @click="setDefaultValues()"
                :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView" 
                block
                color="secondary"
                style="margin-top: 15px;"
                class="hoverableVButton"
              >
                <v-icon size="large" start>mdi-backspace</v-icon>
                <h3>LIMPIAR</h3>
              </v-btn>
            </template>
            <span style="width: 400px; display: block;">Al presionar este botón, se limpiarán los resultados de la búsqueda actual, y se reestablecerán todos los filtros de búsqueda a sus valores por defecto</span>
          </v-tooltip>
        </v-card>
      </v-card>
    </template>
    <div class="contentContainer">
      <template v-if="loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView == true">
        <AppLoaderScreen
          :appLogoSize="'x-small'"
          :loadingText="'Cargando reporte de seguimientos de producto'"
          :dotsToAnimate="3"
        ></AppLoaderScreen>
      </template>
      <template v-else-if="display.CRMWhatsappProductFollowupSummary == null">
        <div style="min-height: 100%; height: 100%; max-height: 100%; min-width: 100%; width: 100%; max-width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;">
          <v-icon color="indigo" style="margin-bottom: 10px;">mdi-information</v-icon>
          <div style="display: flex; align-items: center; gap: 10px;">
            <p style="color: #9e9e9e;">Selecciona uno o más filtros de búsqueda y presiona</p>
            <v-btn
              @click="selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView()"
              :disabled="loader.startup || loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView"
              color="indigo"
              density="comfortable"
              class="hoverableVButton"
            >
              <v-icon start>mdi-magnify</v-icon>
              <p>BUSCAR</p>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-else-if="navigation.noData == true">
        <div style="min-height: 100%; height: 100%; max-height: 100%; min-width: 100%; width: 100%; max-width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;">
          <v-icon color="secondary" style="margin-bottom: 10px;">mdi-alert-circle</v-icon>
          <p style="color: #9e9e9e; margin-bottom: 5px;">No se ha encontrado ningún seguimiento de producto con los filtros de búsqueda aplicados</p>
          <div style="display: flex; align-items: center; gap: 10px;">
            <p style="color: #9e9e9e;">Puedes limpiar los filtros de búsqueda presionando</p>
            <v-btn
              @click="setDefaultValues()"
              color="secondary"
              density="comfortable"
              class="hoverableVButton"
            >
              <v-icon start>mdi-backspace</v-icon>
              <p>LIMPIAR</p>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-else>
        <div style="flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent; padding: 15px;">
          <v-card elevation="2" style="border: 2px solid #343A40;">
            <v-card color="primary" elevation="0" rounded="0" style="padding: 10px;">
              <div style="display: flex; align-items: center; gap: 10px;">
                <template v-if="navigation.searchVisible == false && $vuetify.display.width > 1200">
                  <v-icon
                    @click="navigation.searchVisible = true"
                    class="hoverableElement"
                    style="margin-right: 10px;"
                  >
                    mdi-arrow-right-bottom-bold
                  </v-icon>
                </template>
                <v-icon color="indigo">mdi-package</v-icon>
                <p><strong>Productos asociados</strong></p>
              </div>
            </v-card>
            <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
            <v-data-table
              :headers="computed_CRMWhatsappProductFollowupSummaryProductHeaders"
              :items="display.CRMWhatsappProductFollowupSummary.byProduct"
              :items-per-page="navigation.CRMWhatsappProductFollowupSummaryProductLimit"
              :page="navigation.CRMWhatsappProductFollowupSummaryProductPage"
              fixed-header
              style="max-height: 500px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"
            >
              <template v-slot:headers="{ columns }">
                <tr>
                  <template
                    v-for="column in columns"
                    :key="column.value"
                  >
                    <th>
                      <v-card elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 58px; width: 100%; padding: 0px 25px;">
                        <template v-if="computed_CRMWhatsappProductFollowupSummaryProductHeaders.find(header => header.value == column.value).value != 'productRanking'">
                          <template v-if="computed_CRMWhatsappProductFollowupSummaryProductHeaders.find(header => header.value == column.value).index > 0">
                            <v-icon 
                              @click="updateTableHeaderIndex('CRMWhatsappProductFollowupSummaryProduct', column.value, -1)"
                              color="tertiary"
                              size="x-small"
                              class="hoverableVIcon"
                              style="margin-right: 10px"
                            >
                              mdi-arrow-left-bold
                            </v-icon>
                          </template>
                          <v-icon color="indigo" style="margin-right: 5px;">{{ computed_CRMWhatsappProductFollowupSummaryProductHeaders.find(header => header.value == column.value).icon }}</v-icon>
                          <template v-if="computed_CRMWhatsappProductFollowupSummaryProductHeaders.find(header => header.value == column.value).visible">
                            <p style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ computed_CRMWhatsappProductFollowupSummaryProductHeaders.find(header => header.value == column.value).title }}</strong></p>
                          </template>
                          <v-icon 
                            @click="computed_CRMWhatsappProductFollowupSummaryProductHeaders.find(header => header.value == column.value).visible = !computed_CRMWhatsappProductFollowupSummaryProductHeaders.find(header => header.value == column.value).visible; updateTableVisibility('CRMWhatsappProductFollowupSummaryProduct')"
                            color="tertiary"
                            size="x-small"
                            class="hoverableVIcon"
                          >
                            mdi-{{ computed_CRMWhatsappProductFollowupSummaryProductHeaders.find(header => header.value == column.value).visible ? 'eye' : 'eye-off' }}
                          </v-icon>
                          <template v-if="computed_CRMWhatsappProductFollowupSummaryProductHeaders.find(header => header.value == column.value).index < computed_CRMWhatsappProductFollowupSummaryProductHeaders.length - 1">
                            <v-icon
                              @click="updateTableHeaderIndex('CRMWhatsappProductFollowupSummaryProduct', column.value, 1)"
                              color="tertiary"
                              size="x-small"
                              class="hoverableVIcon"
                              style="margin-left: 10px"
                            >
                              mdi-arrow-right-bold
                            </v-icon>
                          </template>
                        </template>
                      </v-card>
                      <v-card color="grey-lighten-2" elevation="0" rounded="0" style="height: 1px;"></v-card>
                    </th>
                  </template>
                </tr>
              </template>
              <template v-slot:item="row">
                <tr>
                  <template
                    v-for="header in computed_CRMWhatsappProductFollowupSummaryProductHeaders"
                    :key="header.value"
                  >
                    <td>
                      <template v-if="header.value == 'productRanking' && display.CRMWhatsappProductFollowupSummaryProductHeaders.find(currentCRMWhatsappProductFollowupSummaryProductHeader => currentCRMWhatsappProductFollowupSummaryProductHeader.value == header.value).visible">
                        <v-chip
                          :color="row.item.productRanking < display.CRMWhatsappProductFollowupSummary.byProduct.length / 3 ? 'success' : (row.item.productRanking < display.CRMWhatsappProductFollowupSummary.byProduct.length * 2 / 3 ? 'warning' : 'error')"
                          variant="flat"
                          elevation="2"
                          density="compact"
                          label
                        >
                          <p style="font-size: large;"><strong>{{ row.item.productRanking + 1 }}</strong></p>
                        </v-chip>
                      </template>
                      <template v-else-if="header.value == 'product' && display.CRMWhatsappProductFollowupSummaryProductHeaders.find(currentCRMWhatsappProductFollowupSummaryProductHeader => currentCRMWhatsappProductFollowupSummaryProductHeader.value == header.value).visible">
                        <div style="display: flex; align-items: center; gap: 10px;">
                          <v-hover>
                            <template v-slot="{ isHovering, props: hoverProps }">
                              <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                                <v-tooltip text="Ver imagen del producto" location="top">
                                  <template v-slot:activator="{ props: tooltipProps }">
                                    <img
                                      v-bind="tooltipProps"
                                      @click="$root.dialogControllerComponent.openDialog('imageDialog', {'imageURL': row.item.productImageURL})"
                                      :src="row.item.productImageURL || require('@/assets/images/placeholderImage.png')"
                                      draggable="false"
                                      class="hoverableImage"
                                      style="width: 35px; height: 35px; border-radius: 50%; object-fit: cover; border: 2px solid #3F51B5; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);"
                                    >
                                  </template>
                                </v-tooltip>
                              </template>
                              <template v-else>
                                <img
                                  v-bind="hoverProps"
                                  @click="$root.dialogControllerComponent.openDialog('imageDialog', {'imageURL': row.item.productImageURL})"
                                  :src="row.item.productImageURL || require('@/assets/images/placeholderImage.png')"
                                  draggable="false"
                                  class="hoverableImage"
                                  style="width: 35px; height: 35px; border-radius: 50%; object-fit: cover; border: 2px solid #3F51B5; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);"
                                >
                              </template>
                            </template>
                          </v-hover>
                          <div>
                            <p style="white-space: nowrap;">{{ row.item.productName }}</p>
                            <p style="white-space: nowrap; font-size: smaller; color: #3F51B5;"><strong>{{ row.item.productSKU }}</strong></p>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="header.value == 'unitaryProductCost' && display.CRMWhatsappProductFollowupSummaryProductHeaders.find(currentCRMWhatsappProductFollowupSummaryProductHeader => currentCRMWhatsappProductFollowupSummaryProductHeader.value == header.value).visible">
                        <p>{{ $displayFunctions.default.parseAmountToDisplay(row.item.unitaryProductCost) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                      </template>
                      <template v-else-if="header.value == 'unitaryProductPrice' && display.CRMWhatsappProductFollowupSummaryProductHeaders.find(currentCRMWhatsappProductFollowupSummaryProductHeader => currentCRMWhatsappProductFollowupSummaryProductHeader.value == header.value).visible">
                        <p>{{ $displayFunctions.default.parseAmountToDisplay(row.item.unitaryProductPrice) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                      </template>
                      <template v-else-if="header.value == 'unitaryProductUtility' && display.CRMWhatsappProductFollowupSummaryProductHeaders.find(currentCRMWhatsappProductFollowupSummaryProductHeader => currentCRMWhatsappProductFollowupSummaryProductHeader.value == header.value).visible">
                        <p>{{ $displayFunctions.default.parseAmountToDisplay(row.item.unitaryProductUtility) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                      </template>
                      <template v-else-if="header.value == 'productAmount' && display.CRMWhatsappProductFollowupSummaryProductHeaders.find(currentCRMWhatsappProductFollowupSummaryProductHeader => currentCRMWhatsappProductFollowupSummaryProductHeader.value == header.value).visible">
                        <p>{{ $displayFunctions.default.parseAmountToDisplay(row.item.productAmount) }}</p>
                      </template>
                      <template v-else-if="header.value == 'totalProductCost' && display.CRMWhatsappProductFollowupSummaryProductHeaders.find(currentCRMWhatsappProductFollowupSummaryProductHeader => currentCRMWhatsappProductFollowupSummaryProductHeader.value == header.value).visible">
                        <p>{{ $displayFunctions.default.parseAmountToDisplay(row.item.productCost) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                      </template>
                      <template v-else-if="header.value == 'totalProductPrice' && display.CRMWhatsappProductFollowupSummaryProductHeaders.find(currentCRMWhatsappProductFollowupSummaryProductHeader => currentCRMWhatsappProductFollowupSummaryProductHeader.value == header.value).visible">
                        <p>{{ $displayFunctions.default.parseAmountToDisplay(row.item.productPrice) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                      </template>
                      <template v-else-if="header.value == 'totalProductUtility' && display.CRMWhatsappProductFollowupSummaryProductHeaders.find(currentCRMWhatsappProductFollowupSummaryProductHeader => currentCRMWhatsappProductFollowupSummaryProductHeader.value == header.value).visible">
                        <p>{{ $displayFunctions.default.parseAmountToDisplay(row.item.productUtility) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                      </template>
                    </td>
                  </template>
                </tr>
              </template>
              <template v-slot:bottom></template>
            </v-data-table>
            <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
            <v-card elevation="0" rounded="0" color="primary" class="footerContainer">
              <div style="display: flex; flex-direction: column; gap: 5px;">
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo" size="small">mdi-numeric</v-icon>
                  <p style="font-size: small;"><strong>Cantidad total: </strong>{{ $displayFunctions.default.parseAmountToDisplay(computed_totalProductAmount) }}</p>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo" size="small">mdi-cash-minus</v-icon>
                  <p style="font-size: small;"><strong>Costo total: </strong>{{ $displayFunctions.default.parseAmountToDisplay(computed_totalProductCost) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo" size="small">mdi-cash-plus</v-icon>
                  <p style="font-size: small;"><strong>Precio total: </strong>{{ $displayFunctions.default.parseAmountToDisplay(computed_totalProductPrice) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                </div>
                <div style="display: flex; gap: 5px; align-items: center;">
                  <v-icon color="indigo" size="small">mdi-cash-sync</v-icon>
                  <p style="font-size: small;"><strong>Utilidad total: </strong>{{ $displayFunctions.default.parseAmountToDisplay(computed_totalProductUtility) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                </div>
              </div>
              <div class="paginationContainer">
                <v-pagination
                  v-model="navigation.CRMWhatsappProductFollowupSummaryProductPage"
                  :length="Math.ceil(display.CRMWhatsappProductFollowupSummary.byProduct.length / navigation.CRMWhatsappProductFollowupSummaryProductLimit)"
                  :total-visible="5"
                  density="compact"
                  size="small"
                ></v-pagination>
                <p style="font-size: x-small;">{{ (display.CRMWhatsappProductFollowupSummary.byProduct.length == 0) ? '0 de 0 productos' : `${(navigation.CRMWhatsappProductFollowupSummaryProductPage - 1) * navigation.CRMWhatsappProductFollowupSummaryProductLimit + 1} - ${Math.min(navigation.CRMWhatsappProductFollowupSummaryProductPage * navigation.CRMWhatsappProductFollowupSummaryProductLimit, display.CRMWhatsappProductFollowupSummary.byProduct.length)} de ${display.CRMWhatsappProductFollowupSummary.byProduct.length} productos`}}</p>
              </div>
            </v-card>
          </v-card>
          <v-card elevation="2" style="border: 2px solid #343A40; margin-top: 15px;">
            <v-card color="primary" elevation="0" rounded="0" style="padding: 10px;">
              <div style="display: flex; align-items: center; gap: 10px;">
                <v-icon color="indigo">mdi-cog</v-icon>
                <p><strong>Categorización de productos</strong></p>
              </div>
            </v-card>
            <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
            <v-treeview
              :items="computed_CRMWhatsappProductFollowupSummaryByProductCategory"
              item-value="id"
              item-title="title"
              item-children="children"
              density="dense"
              expand-icon="mdi-chevron-right"
              collapse-icon="mdi-chevron-down"
              open-on-click
              style="max-height: 800px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent; -ms-overflow-style: none;"
            >
              <template v-slot:prepend="{ item }">
                <template v-if="item.raw.type == 'productCategory'">
                  <v-chip
                    :color="item.raw.productCategoryRanking < item.raw.siblingCount / 3 ? 'success' : (item.raw.productCategoryRanking < item.raw.siblingCount * 2 / 3 ? 'warning' : 'error')"
                    variant="flat"
                    elevation="2"
                    density="comfortable"
                    label
                    style="margin-right: 20px;"
                  >
                    <p style="font-size: large;"><strong>{{ item.raw.productCategoryRanking + 1 }}</strong></p>
                  </v-chip>
                </template>
                <template v-else-if="item.raw.type == 'productBrand'">
                  <v-chip
                    :color="item.raw.productBrandRanking < item.raw.siblingCount / 3 ? 'success' : (item.raw.productBrandRanking < item.raw.siblingCount * 2 / 3 ? 'warning' : 'error')"
                    variant="flat"
                    elevation="2"
                    density="compact"
                    label
                    style="margin-right: 20px;"
                  >
                    <p><strong>{{ item.raw.productBrandRanking + 1 }}</strong></p>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip
                    :color="item.raw.productModelRanking < item.raw.siblingCount / 3 ? 'success' : (item.raw.productModelRanking < item.raw.siblingCount * 2 / 3 ? 'warning' : 'error')"
                    variant="flat"
                    elevation="2"
                    density="dense"
                    label
                    style="margin-right: 20px;"
                  >
                    <p style="font-size: small;"><strong>{{ item.raw.productModelRanking + 1 }}</strong></p>
                  </v-chip>
                </template>
              </template>
              <template v-slot:title="{ item }">
                <p
                  :style="item.raw.type == 'productCategory' ? 'font-size: large;' : (item.raw.type == 'productModel' ? 'font-size: small;' : null)"
                >
                  {{ item.title }}
                </p>
                <p style="font-size: x-small; color: #9e9e9e;">{{ {'productCategory': 'Categoría', 'productBrand': 'Marca', 'productModel': 'Modelo'}[item.raw.type] }} de producto</p>
              </template>
              <template v-slot:append="{ item }">
                <div style="display: flex; flex-direction: column; gap: 5px; margin: 10px 0px;">
                  <div style="display: flex; gap: 5px; align-items: center;">
                    <v-icon color="indigo" size="small">mdi-numeric</v-icon>
                    <p style="font-size: small;"><strong>Cantidad total: </strong>{{ $displayFunctions.default.parseAmountToDisplay(item.raw.productAmount) }}</p>
                  </div>
                  <div style="display: flex; gap: 5px; align-items: center;">
                    <v-icon color="indigo" size="small">mdi-cash-minus</v-icon>
                    <p style="font-size: small;"><strong>Costo total: </strong>{{ $displayFunctions.default.parseAmountToDisplay(item.raw.productCost) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                  </div>
                  <div style="display: flex; gap: 5px; align-items: center;">
                    <v-icon color="indigo" size="small">mdi-cash-plus</v-icon>
                    <p style="font-size: small;"><strong>Precio total: </strong>{{ $displayFunctions.default.parseAmountToDisplay(item.raw.productPrice) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                  </div>
                  <div style="display: flex; gap: 5px; align-items: center;">
                    <v-icon color="indigo" size="small">mdi-cash-sync</v-icon>
                    <p style="font-size: small;"><strong>Utilidad total: </strong>{{ $displayFunctions.default.parseAmountToDisplay(item.raw.productUtility) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>CRC</strong></span></p>
                  </div>
                </div>
              </template>
            </v-treeview>
          </v-card>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
  .v-data-table th {
    padding: 0 !important;
  }
  .mainContainer {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    overflow: hidden;
    margin-top: 0;
    padding-top: 0;
  }
  .navigationContainer {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #3F51B5 transparent;
    -ms-overflow-style: none;
    width: 25%;
  }
  .contentContainer {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .footerContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    padding: 10px;
  }
  .paginationContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: auto;
  }
  @media (max-width: 1200px) {
    .mainContainer {
      flex-direction: column;
      height: auto;
      overflow-y: auto;
    }
    .navigationContainer {
      width: 100%;
    }
    .contentContainer {
      min-height: 900px;
      max-height: 900px;
    }
    .footerContainer {
      grid-template-columns: 1fr;
    }
    .paginationContainer {
      margin-left: 0;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';
  import LZString from 'lz-string';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      AppLoaderScreen
    },
    data: () => 
    ({
      input: 
      {
        date: [],
        CRMWhatsappContactID: [],
        searchedCRMWhatsappContactID: null,
        allCRMWhatsappContactIDSelected: false,
        CRMLocalityID: [],
        allCRMLocalityIDSelected: false,
        CRMAgentID: [],
        allCRMAgentIDSelected: false,
        CRMWhatsappProductFollowupStatus: [],
        allCRMWhatsappProductFollowupStatusSelected: false,
        CRMWhatsappProductFollowupNote: null,
        productID: [],
        searchedProductID: null,
        allProductIDSelected: false,
        productCategoryID: [],
        allProductCategoryIDSelected: false,
        productBrandID: [],
        allProductBrandIDSelected: false,
        productModelID: [],
        allProductModelIDSelected: false,
        productFlavorID: [],
        allProductFlavorIDSelected: false,
        productNicotineLevelID: [],
        allProductNicotineLevelIDSelected: false,
        productSizeID: [],
        allProductSizeIDSelected: false,
        productProviderID: [],
        allProductProviderIDSelected: false,
        productTagID: [],
        allProductTagIDSelected: false
      },
      display: 
      {
        CRMWhatsappContact: [],
        CRMWhatsappProductFollowupStatus:
        [
          {value: 'Pendiente (esperando al contacto)', title: 'Pendiente (esperando al contacto)', color: 'error'},
          {value: 'Pendiente (esperando inventario)', title: 'Pendiente (esperando inventario)', color: 'error'},
          {value: 'Pendiente (otro)', title: 'Pendiente (otro)', color: 'error'},
          {value: 'Finalizado', title: 'Finalizado', color: 'success'},
          {value: 'Cancelado', title: 'Cancelado', color: 'grey'}
        ],
        product: [],
        productCategory: [],
        productBrand: [],
        productModel: [],
        productFlavor: [],
        productNicotineLevel: [],
        productSize: [],
        productProvider: [],
        productTag: [],
        CRMWhatsappProductFollowupSummary: null,
        CRMWhatsappProductFollowupSummaryProductHeaders: []
      },
      navigation: 
      {
        errorOnStartup: false,
        searchVisible: true,
        noData: false,
        CRMWhatsappProductFollowupSummaryProductLimit: 100,
        CRMWhatsappProductFollowupSummaryProductPage: 1
      },
      loader: 
      {
        startup: false,
        selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMLocalities: [],
        CRMAgent: null,
        CRMAgents: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed:
    {
      computed_formattedDate(){
        if (this.input.date.length == 0) return null;
        else if (this.input.date.length == 1) return this.$displayFunctions.default.fromDatetimeToDDMMYYYY(this.input.date[0]);
        return this.$displayFunctions.default.fromDatetimeToDDMMYYYY(this.input.date[0]) + ' al ' + this.$displayFunctions.default.fromDatetimeToDDMMYYYY(this.input.date[this.input.date.length - 1]);
      },
      computed_CRMWhatsappContact(){
        if (this.input.searchedCRMWhatsappContactID == null) return this.display.CRMWhatsappContact.slice(0, 250);
        else return this.display.CRMWhatsappContact.filter(currentDisplayCRMWhatsappContact =>
          currentDisplayCRMWhatsappContact.CRMWhatsappContactID.toString().includes(this.input.searchedCRMWhatsappContactID)
          ||
          currentDisplayCRMWhatsappContact.CRMWhatsappContactName.toLowerCase().includes(this.input.searchedCRMWhatsappContactID.toLowerCase())
          ||
          currentDisplayCRMWhatsappContact.CRMWhatsappContactPhoneNumber.toLowerCase().includes(this.input.searchedCRMWhatsappContactID.toLowerCase())
        ).slice(0, 250);
      },
      computed_CRMWhatsappProductFollowupSummaryProductHeaders(){
        return this.display.CRMWhatsappProductFollowupSummaryProductHeaders.slice().sort((CRMWhatsappProductFollowupSummaryProductHeaderA, CRMWhatsappProductFollowupSummaryProductHeaderB) => CRMWhatsappProductFollowupSummaryProductHeaderA.index - CRMWhatsappProductFollowupSummaryProductHeaderB.index);
      },
      computed_totalProductAmount(){
        if (this.display.CRMWhatsappProductFollowupSummary == null) return 0;
        return this.display.CRMWhatsappProductFollowupSummary.byProduct.reduce((totalProductAmount, currentDatabaseProduct) => totalProductAmount + currentDatabaseProduct.productAmount, 0);
      },
      computed_totalProductCost(){
        if (this.display.CRMWhatsappProductFollowupSummary == null) return 0;
        return this.display.CRMWhatsappProductFollowupSummary.byProduct.reduce((totalProductCost, currentDatabaseProduct) => totalProductCost + currentDatabaseProduct.productCost, 0);
      },
      computed_totalProductPrice(){
        if (this.display.CRMWhatsappProductFollowupSummary == null) return 0;
        return this.display.CRMWhatsappProductFollowupSummary.byProduct.reduce((totalProductPrice, currentDatabaseProduct) => totalProductPrice + currentDatabaseProduct.productPrice, 0);
      },
      computed_totalProductUtility(){
        if (this.display.CRMWhatsappProductFollowupSummary == null) return 0;
        return this.display.CRMWhatsappProductFollowupSummary.byProduct.reduce((totalProductUtility, currentDatabaseProduct) => totalProductUtility + currentDatabaseProduct.productUtility, 0);
      },
      computed_CRMWhatsappProductFollowupSummaryByProductCategory(){
        if (this.display.CRMWhatsappProductFollowupSummary == null) return [];
        return this.display.CRMWhatsappProductFollowupSummary.byProductCategory.map(currentDatabaseProductCategory => ({
          'id': `productCategory_${currentDatabaseProductCategory.productCategoryID}`,
          'title': currentDatabaseProductCategory.productCategoryName,
          'raw': 
          {
            'type': currentDatabaseProductCategory.type,
            'productCategoryRanking': currentDatabaseProductCategory.productCategoryRanking,
            'siblingCount': this.display.CRMWhatsappProductFollowupSummary.byProductCategory.length,
            'productAmount': currentDatabaseProductCategory.productAmount,
            'productCost': currentDatabaseProductCategory.productCost,
            'productPrice': currentDatabaseProductCategory.productPrice,
            'productUtility': currentDatabaseProductCategory.productUtility
          },
          'children': currentDatabaseProductCategory.byProductBrand.map(currentDatabaseProductBrand => ({
            'id': `productBrand_${currentDatabaseProductBrand.productBrandID}`,
            'title': currentDatabaseProductBrand.productBrandName,
            'raw':
            {
              'type': currentDatabaseProductBrand.type,
              'productBrandRanking': currentDatabaseProductBrand.productBrandRanking,
              'siblingCount': currentDatabaseProductCategory.byProductBrand.length,
              'productAmount': currentDatabaseProductBrand.productAmount,
              'productCost': currentDatabaseProductBrand.productCost,
              'productPrice': currentDatabaseProductBrand.productPrice,
              'productUtility': currentDatabaseProductBrand.productUtility
            },
            'children': currentDatabaseProductBrand.byProductModel.map(currentDatabaseProductModel => ({
              'id': `productModel_${currentDatabaseProductModel.productModelID}`,
              'title': currentDatabaseProductModel.productModelName,
              'raw':
              {
                'type': currentDatabaseProductModel.type,
                'productModelRanking': currentDatabaseProductModel.productModelRanking,
                'siblingCount': currentDatabaseProductBrand.byProductModel.length,
                'productAmount': currentDatabaseProductModel.productAmount,
                'productCost': currentDatabaseProductModel.productCost,
                'productPrice': currentDatabaseProductModel.productPrice,
                'productUtility': currentDatabaseProductModel.productUtility
              }
            }))
          }))
        }));
      }
    },

    methods:
    {
      async selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView(){
        this.loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView = true;
        const selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryViewRequestBody =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'date_start': this.input.date[0],
          'date_end': this.input.date[this.input.date.length - 1],
          'CRMWhatsappContactID': this.input.CRMWhatsappContactID == this.display.CRMWhatsappContact.length ? [] : (this.input.CRMWhatsappContactID.length <= (this.display.CRMWhatsappContact.length - this.input.CRMWhatsappContactID.length) ? this.input.CRMWhatsappContactID : this.display.CRMWhatsappContact.filter(currentDisplayCRMWhatsappContact => !this.input.CRMWhatsappContactID.includes(currentDisplayCRMWhatsappContact.CRMWhatsappContactID)).map(currentDisplayCRMWhatsappContact => currentDisplayCRMWhatsappContact.CRMWhatsappContactID)),
          'CRMWhatsappContactIDIn': this.input.CRMWhatsappContactID.length <= (this.display.CRMWhatsappContact.length - this.input.CRMWhatsappContactID.length),
          'CRMLocalityID': this.input.CRMLocalityID.length == this.systemInformationData.CRMLocalities.length ? [] : (this.input.CRMLocalityID.length <= (this.systemInformationData.CRMLocalities.length - this.input.CRMLocalityID.length) ? this.input.CRMLocalityID : this.systemInformationData.CRMLocalities.filter(currentDisplayCRMLocality => !this.input.CRMLocalityID.includes(currentDisplayCRMLocality.CRMLocalityID)).map(currentDisplayCRMLocality => currentDisplayCRMLocality.CRMLocalityID)),
          'CRMLocalityIDIn': this.input.CRMLocalityID.length <= (this.systemInformationData.CRMLocalities.length - this.input.CRMLocalityID.length),
          'CRMAgentID': this.input.CRMAgentID.length == this.systemInformationData.CRMAgents.length ? [] : (this.input.CRMAgentID.length <= (this.systemInformationData.CRMAgents.length - this.input.CRMAgentID.length) ? this.input.CRMAgentID : this.systemInformationData.CRMAgents.filter(currentDisplayCRMAgent => !this.input.CRMAgentID.includes(currentDisplayCRMAgent.CRMAgentID)).map(currentDisplayCRMAgent => currentDisplayCRMAgent.CRMAgentID)),
          'CRMAgentIDIn': this.input.CRMAgentID.length <= (this.systemInformationData.CRMAgents.length - this.input.CRMAgentID.length),
          'CRMWhatsappProductFollowupStatus': this.input.CRMWhatsappProductFollowupStatus.length == this.display.CRMWhatsappProductFollowupStatus.length ? [] : (this.input.CRMWhatsappProductFollowupStatus.length <= (this.display.CRMWhatsappProductFollowupStatus.length - this.input.CRMWhatsappProductFollowupStatus.length) ? this.input.CRMWhatsappProductFollowupStatus : this.display.CRMWhatsappProductFollowupStatus.filter(currentDisplayCRMWhatsappProductFollowupStatus => !this.input.CRMWhatsappProductFollowupStatus.includes(currentDisplayCRMWhatsappProductFollowupStatus.value)).map(currentDisplayCRMWhatsappProductFollowupStatus => currentDisplayCRMWhatsappProductFollowupStatus.value)),
          'CRMWhatsappProductFollowupStatusIn': this.input.CRMWhatsappProductFollowupStatus.length <= (this.display.CRMWhatsappProductFollowupStatus.length - this.input.CRMWhatsappProductFollowupStatus.length),
          'CRMWhatsappProductFollowupNote': this.input.CRMWhatsappProductFollowupNote,
          'productID': this.input.productID.length == this.display.product.length ? [] : (this.input.productID.length <= (this.display.product.length - this.input.productID.length) ? this.input.productID : this.display.product.filter(currentDisplayProduct => !this.input.productID.includes(currentDisplayProduct.productID)).map(currentDisplayProduct => currentDisplayProduct.productID)),
          'productIDIn': this.input.productID.length <= (this.display.product.length - this.input.productID.length),
          'productCategoryID': this.input.productCategoryID.length == this.display.productCategory.length ? [] : (this.input.productCategoryID.length <= (this.display.productCategory.length - this.input.productCategoryID.length) ? this.input.productCategoryID : this.display.productCategory.filter(currentDisplayProductCategory => !this.input.productCategoryID.includes(currentDisplayProductCategory.productCategoryID)).map(currentDisplayProductCategory => currentDisplayProductCategory.productCategoryID)),
          'productCategoryIDIn': this.input.productCategoryID.length <= (this.display.productCategory.length - this.input.productCategoryID.length),
          'productBrandID': this.input.productBrandID.length == this.display.productBrand.length ? [] : (this.input.productBrandID.length <= (this.display.productBrand.length - this.input.productBrandID.length) ? this.input.productBrandID : this.display.productBrand.filter(currentDisplayProductBrand => !this.input.productBrandID.includes(currentDisplayProductBrand.productBrandID)).map(currentDisplayProductBrand => currentDisplayProductBrand.productBrandID)),
          'productBrandIDIn': this.input.productBrandID.length <= (this.display.productBrand.length - this.input.productBrandID.length),
          'productModelID': this.input.productModelID.length == this.display.productModel.length ? [] : (this.input.productModelID.length <= (this.display.productModel.length - this.input.productModelID.length) ? this.input.productModelID : this.display.productModel.filter(currentDisplayProductModel => !this.input.productModelID.includes(currentDisplayProductModel.productModelID)).map(currentDisplayProductModel => currentDisplayProductModel.productModelID)),
          'productModelIDIn': this.input.productModelID.length <= (this.display.productModel.length - this.input.productModelID.length),
          'productFlavorID': this.input.productFlavorID.length == this.display.productFlavor.length ? [] : (this.input.productFlavorID.length <= (this.display.productFlavor.length - this.input.productFlavorID.length) ? this.input.productFlavorID : this.display.productFlavor.filter(currentDisplayProductFlavor => !this.input.productFlavorID.includes(currentDisplayProductFlavor.productFlavorID)).map(currentDisplayProductFlavor => currentDisplayProductFlavor.productFlavorID)),
          'productFlavorIDIn': this.input.productFlavorID.length <= (this.display.productFlavor.length - this.input.productFlavorID.length),
          'productNicotineLevelID': this.input.productNicotineLevelID.length == this.display.productNicotineLevel.length ? [] : (this.input.productNicotineLevelID.length <= (this.display.productNicotineLevel.length - this.input.productNicotineLevelID.length) ? this.input.productNicotineLevelID : this.display.productNicotineLevel.filter(currentDisplayProductNicotineLevel => !this.input.productNicotineLevelID.includes(currentDisplayProductNicotineLevel.productNicotineLevelID)).map(currentDisplayProductNicotineLevel => currentDisplayProductNicotineLevel.productNicotineLevelID)),
          'productNicotineLevelIDIn': this.input.productNicotineLevelID.length <= (this.display.productNicotineLevel.length - this.input.productNicotineLevelID.length),
          'productSizeID': this.input.productSizeID.length == this.display.productSize.length ? [] : (this.input.productSizeID.length <= (this.display.productSize.length - this.input.productSizeID.length) ? this.input.productSizeID : this.display.productSize.filter(currentDisplayProductSize => !this.input.productSizeID.includes(currentDisplayProductSize.productSizeID)).map(currentDisplayProductSize => currentDisplayProductSize.productSizeID)),
          'productSizeIDIn': this.input.productSizeID.length <= (this.display.productSize.length - this.input.productSizeID.length),
          'productProviderID': this.input.productProviderID.length == this.display.productProvider.length ? [] : (this.input.productProviderID.length <= (this.display.productProvider.length - this.input.productProviderID.length) ? this.input.productProviderID : this.display.productProvider.filter(currentDisplayProductProvider => !this.input.productProviderID.includes(currentDisplayProductProvider.productProviderID)).map(currentDisplayProductProvider => currentDisplayProductProvider.productProviderID)),
          'productProviderIDIn': this.input.productProviderID.length <= (this.display.productProvider.length - this.input.productProviderID.length),
          'productTagID': this.input.productTagID.length == this.display.productTag.length ? [] : (this.input.productTagID.length <= (this.display.productTag.length - this.input.productTagID.length) ? this.input.productTagID : this.display.productTag.filter(currentDisplayProductTag => !this.input.productTagID.includes(currentDisplayProductTag.productTagID)).map(currentDisplayProductTag => currentDisplayProductTag.productTagID)),
          'productTagIDIn': this.input.productTagID.length <= (this.display.productTag.length - this.input.productTagID.length)
        };
        const selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappProductFollowup/functions/selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView', selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryViewRequestBody);
        if (selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryViewResult.success){
          this.navigation.CRMWhatsappProductFollowupSummaryProductPage = 1;
          this.display.CRMWhatsappProductFollowupSummary = selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryViewResult.result;
          let productRanking = 0;
          this.display.CRMWhatsappProductFollowupSummary.byProduct.forEach(currentDatabaseProduct => {
            currentDatabaseProduct.productRanking = productRanking;
            currentDatabaseProduct.unitaryProductCost = currentDatabaseProduct.productCost / currentDatabaseProduct.productAmount;
            currentDatabaseProduct.unitaryProductPrice = currentDatabaseProduct.productPrice / currentDatabaseProduct.productAmount;
            currentDatabaseProduct.unitaryProductUtility = currentDatabaseProduct.unitaryProductPrice - currentDatabaseProduct.unitaryProductCost;
            currentDatabaseProduct.productUtility = currentDatabaseProduct.productPrice - currentDatabaseProduct.productCost;
            const displayProduct = this.display.product.find(currentDisplayProduct => currentDisplayProduct.productID == currentDatabaseProduct.productID);
            if (displayProduct != null){
              currentDatabaseProduct.productImageURL = displayProduct.productImageURL;
              currentDatabaseProduct.productName = displayProduct.productName;
              currentDatabaseProduct.productSKU = displayProduct.productSKU;
            }
            productRanking = productRanking + 1;
          });
          let productCategoryRanking = 0;
          this.display.CRMWhatsappProductFollowupSummary.byProductCategory.forEach(currentDatabaseProductCategory => {
            currentDatabaseProductCategory.type = 'productCategory';
            currentDatabaseProductCategory.productCategoryRanking = productCategoryRanking;
            currentDatabaseProductCategory.productUtility = currentDatabaseProductCategory.productPrice - currentDatabaseProductCategory.productCost;
            const displayProductCategory = this.display.productCategory.find(currentDisplayProductCategory => currentDisplayProductCategory.productCategoryID == currentDatabaseProductCategory.productCategoryID);
            if (displayProductCategory != null) currentDatabaseProductCategory.productCategoryName = displayProductCategory.productCategoryName;
            let productBrandRanking = 0;
            currentDatabaseProductCategory.byProductBrand.forEach(currentDatabaseProductBrand => {
              currentDatabaseProductBrand.type = 'productBrand';
              currentDatabaseProductBrand.productBrandRanking = productBrandRanking;
              currentDatabaseProductBrand.productUtility = currentDatabaseProductBrand.productPrice - currentDatabaseProductBrand.productCost;
              const displayProductBrand = this.display.productBrand.find(currentDisplayProductBrand => currentDisplayProductBrand.productBrandID == currentDatabaseProductBrand.productBrandID);
              if (displayProductBrand != null) currentDatabaseProductBrand.productBrandName = displayProductBrand.productBrandName;
              let productModelRanking = 0;
              currentDatabaseProductBrand.byProductModel.forEach(currentDatabaseProductModel => {
                currentDatabaseProductModel.type = 'productModel';
                currentDatabaseProductModel.productModelRanking = productModelRanking;
                currentDatabaseProductModel.productUtility = currentDatabaseProductModel.productPrice - currentDatabaseProductModel.productCost;
                const displayProductModel = this.display.productModel.find(currentDisplayProductModel => currentDisplayProductModel.productModelID == currentDatabaseProductModel.productModelID);
                if (displayProductModel != null) currentDatabaseProductModel.productModelName = displayProductModel.productModelName;
                productModelRanking = productModelRanking + 1;
              });
              productBrandRanking = productBrandRanking + 1;
            });
            productCategoryRanking = productCategoryRanking + 1;
          });
          this.navigation.noData = this.display.CRMWhatsappProductFollowupSummary.byProduct.length == 0;
        } else this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView_error', 'error', 'Ha ocurrido un error inesperado al consultar el reporte de seguimientos de producto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        this.loader.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupSummaryView = false;
      },
      async selectCRMWhatsappContactForInput(){
        const selectCRMWhatsappContactForInputRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectCRMWhatsappContactForInputResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/selectCRMWhatsappContactForInput', selectCRMWhatsappContactForInputRequestQuery);
        if (selectCRMWhatsappContactForInputResult.success) this.display.CRMWhatsappContact = selectCRMWhatsappContactForInputResult.result;
        else {
          this.navigation.errorOnStartup = true;
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactForInput_error', 'error', 'Ha ocurrido un error inesperado al consultar el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
      async selectProductSearchParameters(){
        const selectProductSearchParametersRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectProductSearchParametersResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/product/functions/selectProductSearchParameters', selectProductSearchParametersRequestQuery);
        if (selectProductSearchParametersResult.success) {
          this.display.product = selectProductSearchParametersResult.result.products;
          this.display.product.forEach(currentProduct => {
            currentProduct.productAutocomplete = `${currentProduct.productID} - ${currentProduct.productName}`;
          });
          this.display.productCategory = selectProductSearchParametersResult.result.productCategories;
          this.display.productBrand = selectProductSearchParametersResult.result.productBrands;
          this.display.productModel = selectProductSearchParametersResult.result.productModels;
          this.display.productFlavor = selectProductSearchParametersResult.result.productFlavors;
          this.display.productNicotineLevel = selectProductSearchParametersResult.result.productNicotineLevels;
          this.display.productSize = selectProductSearchParametersResult.result.productSizes;
          this.display.productProvider = selectProductSearchParametersResult.result.productProviders;
          this.display.productTag = selectProductSearchParametersResult.result.productTags;
        } else {
          this.navigation.errorOnStartup = true;
          this.$root.notificationDialog.showSystemNotificationDialog('selectProductSearchParameters_error', 'error', 'Ha ocurrido un error inesperado al consultar los parámetros de búsqueda de productos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
      appendProductIntoProductID(){
        if (this.input.searchedProductID != null){
          const displayProduct = this.display.product.find(currentProduct => currentProduct.productID == this.input.searchedProductID);
          if (displayProduct != null){
            if (!this.input.productID.includes(displayProduct.productID)) this.input.productID.push(displayProduct.productID);
          } else this.$root.notificationDialog.showSystemNotificationDialog('appendProductIntoProductID(displayProduct == null)', 'warning', 'No se ha encontrado el producto seleccionado', null, false);  
          this.input.searchedProductID = null;
          this.$generalFunctions.default.blurInput(this, 'productID');
        }
      },
      setDefaultValues(){
        this.input.date = Array.from({length: new Date().getDate()}, (_, i) => new Date(new Date().getFullYear(), new Date().getMonth(), i + 1));
        this.input.CRMWhatsappContactID.length = 0;
        this.input.allCRMWhatsappContactIDSelected = false;
        this.input.CRMLocalityID.length = 0;
        this.input.allCRMLocalityIDSelected = false;
        this.input.CRMAgentID.length = 0;
        this.input.allCRMAgentIDSelected = false;
        this.input.CRMWhatsappProductFollowupStatus.length = 0;
        this.input.allCRMWhatsappProductFollowupStatusSelected = false;
        this.input.CRMWhatsappProductFollowupNote = null;
        this.input.productID.length = 0;
        this.input.allProductIDSelected = false;
        this.input.productCategoryID.length = 0;
        this.input.allProductCategoryIDSelected = false;
        this.input.productBrandID.length = 0;
        this.input.allProductBrandIDSelected = false;
        this.input.productModelID.length = 0;
        this.input.allProductModelIDSelected = false;
        this.input.productFlavorID.length = 0;
        this.input.allProductFlavorIDSelected = false;
        this.input.productNicotineLevelID.length = 0;
        this.input.allProductNicotineLevelIDSelected = false;
        this.input.productSizeID.length = 0;
        this.input.allProductSizeIDSelected = false;
        this.input.productProviderID.length = 0;
        this.input.allProductProviderIDSelected = false;
        this.input.productTagID.length = 0;
        this.input.allProductTagIDSelected = false;
        this.display.CRMWhatsappProductFollowupSummary = null;
        this.navigation.CRMWhatsappProductFollowupSummaryProductPage = 1;
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactID');
        this.updateURLSearchQuery();
      },
      updateURLSearchQuery(){
        if (this.input.date.length == 0) this.input.date = Array.from({length: new Date().getDate()}, (_, i) => new Date(new Date().getFullYear(), new Date().getMonth(), i + 1));
        let searchQuery = 
        {
          '1': this.input.date[0],
          '2': this.input.date[this.input.date.length - 1],
          '3': this.input.CRMWhatsappContactID,
          '4': this.input.CRMLocalityID,
          '5': this.input.CRMAgentID,
          '6': this.input.CRMWhatsappProductFollowupStatus,
          '7': this.input.CRMWhatsappProductFollowupNote,
          '8': this.input.productID,
          '9': this.input.productCategoryID,
          '10': this.input.productBrandID,
          '11': this.input.productModelID,
          '12': this.input.productFlavorID,
          '13': this.input.productNicotineLevelID,
          '14': this.input.productSizeID,
          '15': this.input.productProviderID,
          '16': this.input.productTagID
        };
        searchQuery = Object.fromEntries(Object.entries(searchQuery).filter(([ , v]) => v != null && v != undefined));
        const searchQueryCompressed = LZString.compressToEncodedURIComponent(JSON.stringify(searchQuery));
        this.$router.replace({query: {searchQuery: searchQueryCompressed}});
        this.display.CRMWhatsappProductFollowupSummary = null;
        this.navigation.noData = false;
      },
      async decodeURLSearchQuery(){
        let searchQuery = this.$route.query.searchQuery;
        if (searchQuery){
          searchQuery = JSON.parse(LZString.decompressFromEncodedURIComponent(searchQuery));
          if (searchQuery['1'] && !isNaN(new Date(searchQuery['1']).getTime()) && searchQuery['2'] && !isNaN(new Date(searchQuery['2']).getTime())) this.input.date = (() => { const s = new Date(searchQuery['1']); const e = new Date(searchQuery['2']); s.setHours(0,0,0,0); e.setHours(0,0,0,0); const d = Math.floor((e - s) / 86400000) + 1; return Array.from({length: d}, (_, i) => new Date(s.getTime() + i * 86400000)); })();
          else this.input.date = Array.from({length: new Date().getDate()}, (_, i) => new Date(new Date().getFullYear(), new Date().getMonth(), i + 1));
          this.input.CRMWhatsappContactID = searchQuery['3'] || [];
          this.input.allCRMWhatsappContactIDSelected = searchQuery['3'].length == this.display.CRMWhatsappContact.length;
          this.input.CRMLocalityID = searchQuery['4'] || [];
          this.input.allCRMLocalityIDSelected = searchQuery['4'].length == this.systemInformationData.CRMLocalities.length;
          this.input.CRMAgentID = searchQuery['5'] || [];
          this.input.allCRMAgentIDSelected = searchQuery['5'].length == this.systemInformationData.CRMAgents.length;
          this.input.CRMWhatsappProductFollowupStatus = searchQuery['6'] || [];
          this.input.allCRMWhatsappProductFollowupStatusSelected = searchQuery['6'].length == this.display.CRMWhatsappProductFollowupStatus.length;
          this.input.CRMWhatsappProductFollowupNote = searchQuery['7'];
          this.input.productID = searchQuery['8'] || [];
          this.input.allProductIDSelected = searchQuery['8'].length == this.display.product.length;
          this.input.productCategoryID = searchQuery['9'] || [];
          this.input.allProductCategoryIDSelected = searchQuery['9'].length == this.display.productCategory.filter(currentProductCategory => currentProductCategory.productCategoryID != null).length;
          this.input.productBrandID = searchQuery['10'] || [];
          this.input.allProductBrandIDSelected = searchQuery['10'].length == this.display.productBrand.filter(currentProductBrand => currentProductBrand.productBrandID != null).length;
          this.input.productModelID = searchQuery['11'] || [];
          this.input.allProductModelIDSelected = searchQuery['11'].length == this.display.productModel.filter(currentProductModel => currentProductModel.productModelID != null).length;
          this.input.productFlavorID = searchQuery['12'] || [];
          this.input.allProductFlavorIDSelected = searchQuery['12'].length == this.display.productFlavor.filter(currentProductFlavor => currentProductFlavor.productFlavorID != null).length;
          this.input.productNicotineLevelID = searchQuery['13'] || [];
          this.input.allProductNicotineLevelIDSelected = searchQuery['13'].length == this.display.productNicotineLevel.filter(currentProductNicotineLevel => currentProductNicotineLevel.productNicotineLevelID != null).length;
          this.input.productSizeID = searchQuery['14'] || [];
          this.input.allProductSizeIDSelected = searchQuery['14'].length == this.display.productSize.filter(currentProductSize => currentProductSize.productSizeID != null).length;
          this.input.productProviderID = searchQuery['15'] || [];
          this.input.allProductProviderIDSelected = searchQuery['15'].length == this.display.productProvider.filter(currentProductProvider => currentProductProvider.productProviderID != null).length;
          this.input.productTagID = searchQuery['16'] || [];
          this.input.allProductTagIDSelected = searchQuery['16'].length == this.display.productTag.filter(currentProductTag => currentProductTag.productTagID != null).length;
        } else this.setDefaultValues();
      },
      updateTableHeaderIndex(tableName, headerValue, headerIndexChange){
        const updatedTableHeader = this.display[`${tableName}Headers`].find(header => header.value == headerValue);
        const swappedTableHeader = this.display[`${tableName}Headers`].find(header => header.index == (this.display[`${tableName}Headers`].find(header => header.value == headerValue).index + headerIndexChange));
        if (updatedTableHeader && swappedTableHeader) [updatedTableHeader.index, swappedTableHeader.index] = [swappedTableHeader.index, updatedTableHeader.index];
        localStorage.setItem(`CRMWhatsappProductFollowupSummaryView_${tableName}Headers`, JSON.stringify(this.display[`${tableName}Headers`]));      
      },
      updateTableVisibility(tableName){
        localStorage.setItem(`CRMWhatsappProductFollowupSummaryView_${tableName}Headers`, JSON.stringify(this.display[`${tableName}Headers`]));      
      },
      async prepareTables(){
        const CRMWhatsappProductFollowupSummaryProductHeaders = 
        [
          {title: null, value: 'productRanking', icon: null, visible: true},
          {title: 'PRODUCTO', value: 'product', icon: 'mdi-package', visible: true},
          {title: 'COSTO', value: 'unitaryProductCost', icon: 'mdi-cash-minus', visible: true},
          {title: 'PRECIO', value: 'unitaryProductPrice', icon: 'mdi-cash-plus', visible: true},
          {title: 'UTILIDAD', value: 'unitaryProductUtility', icon: 'mdi-cash-sync', visible: true},
          {title: 'CANTIDAD', value: 'productAmount', icon: 'mdi-numeric', visible: true},
          {title: 'COSTO TOTAL', value: 'totalProductCost', icon: 'mdi-cash-minus', visible: true},
          {title: 'PRECIO TOTAL', value: 'totalProductPrice', icon: 'mdi-cash-plus', visible: true},
          {title: 'UTILIDAD TOTAL', value: 'totalProductUtility', icon: 'mdi-cash-sync', visible: true}
        ].map((header, index) => ({ ...header, index: index }));
        let localStorageHeaders = JSON.parse(localStorage.getItem('CRMWhatsappProductFollowupSummaryView_CRMWhatsappProductFollowupSummaryProductHeaders') || JSON.stringify(CRMWhatsappProductFollowupSummaryProductHeaders));
        for (const localStorageHeader of localStorageHeaders){
          const CRMWhatsappProductFollowupSummaryProductHeader = CRMWhatsappProductFollowupSummaryProductHeaders.find(CRMWhatsappProductFollowupSummaryProductHeader => CRMWhatsappProductFollowupSummaryProductHeader.value == localStorageHeader.value);
          if (CRMWhatsappProductFollowupSummaryProductHeader){
            if (localStorageHeader.visible != null) CRMWhatsappProductFollowupSummaryProductHeader.visible = localStorageHeader.visible;
            if (localStorageHeader.index != null) CRMWhatsappProductFollowupSummaryProductHeader.index = localStorageHeader.index;
          }
        }
        this.display.CRMWhatsappProductFollowupSummaryProductHeaders = CRMWhatsappProductFollowupSummaryProductHeaders.slice().sort((CRMWhatsappProductFollowupSummaryProductHeaderA, CRMWhatsappProductFollowupSummaryProductHeaderB) => CRMWhatsappProductFollowupSummaryProductHeaderA.index - CRMWhatsappProductFollowupSummaryProductHeaderB.index);
      },
      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){ 
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
            this.input.CRMWhatsappProductFollowupCreationCRMAgentID = [this.systemInformationData.CRMAgent.CRMAgentID];
          } else {
            this.navigation.errorOnStartup = true;
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al consultar la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.navigation.errorOnStartup = true;
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al consultar la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },
    async mounted(){
      this.loader.startup = true;
      await this.getSystemInformationData();
      await Promise.all([
        this.selectProductSearchParameters(),
        this.selectCRMWhatsappContactForInput()
      ]);
      if (this.navigation.errorOnStartup == false){
        await this.decodeURLSearchQuery();
        await this.prepareTables();
        this.loader.startup = false;
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactID');
      }
    },
    beforeUnmount(){
      if (this.systemInformationData.updateSubscription) systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
      this.systemInformationData.updateSubscription = null;
    }
  }
</script>